import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {firstAuthorizedRoute, TranslationKeys, userProfileRoute} from 'utils/constants/routeConstants';
import {IStore} from 'redux/interface';
import {startLoginAction} from 'redux/auth/authAsyncActions';

import MeetYourTeam from 'components/meet-your-team';
import MainArea from 'components/main-area';

import './styles.scss';
import {IUserProfile} from '@wholesalechange/chatcomponent';

export const Home: React.FunctionComponent = () => {
  const {
    auth0User,
    isFinishAuthorization,
    userProfile,
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [shouldRedirectToSettings, setShouldRedirectToSettings] = useState<boolean | undefined>(undefined);

  useGetTranslations({
    translationKey: TranslationKeys.Home
  });
  const {state: appLocState} = useLocation();

  useEffect(() => {
    if (userProfile && settings && settings.profileSettings
      && settings.profileSettings.blockUntilRequiredFieldsSet && settings.profileSettings.additionalFields) {
      const requiredFields = settings.profileSettings.additionalFields
        .filter(field => field.required)
        .map(field => field.name);

      setShouldRedirectToSettings(requiredFields.some(field => !userProfile[field as keyof IUserProfile]));
    }
  }, [userProfile, settings]);

  useEffect(() => {
    if (auth0User) {
      if (shouldRedirectToSettings === false) {
        if (appLocState) {
          navigate(appLocState.from, {replace: true});
        } else {
          navigate(firstAuthorizedRoute, {replace: true});
        }
      }

      if (shouldRedirectToSettings) {
        navigate(userProfileRoute, {replace: true});
      }
    }
    if (!auth0User && appLocState && isFinishAuthorization) {
      if (appLocState) {
        dispatch(startLoginAction(appLocState.from.pathname + appLocState.from.hash));
      }
    }
  }, [auth0User, appLocState, isFinishAuthorization, shouldRedirectToSettings]);

  useEffect(() => {
    if (auth0User) {
      if (appLocState) {
        navigate(appLocState.from, {replace: true});
      } else {
        navigate(firstAuthorizedRoute, {replace: true});
      }
    }
    if (!auth0User && appLocState && isFinishAuthorization) {
      if (appLocState) {
        dispatch(startLoginAction(appLocState.from.pathname + appLocState.from.hash));
      }
    }
  }, [auth0User, appLocState, isFinishAuthorization]);

  return <div className="home">
    <h1 className="visually-hidden">
      <FormattedMessage
        id={'gritx.home.access.title'}
        defaultMessage={'Home page Peak website'}
      />
    </h1>
    <MainArea/>
    {/* <MeetYourTeam/>*/}
  </div>;
};
